import { PurchaseOrderInvoiceLabel } from '../models/purchase-order/purchase-order-invoice-status.model';
import { PurchaseOrder, PurchaseOrderInvoiceStatus } from '../models/purchase-order/purchase-order.model';
import { ReasonRemoveOrder } from '../values/reson-remove-order.value';

export function getPurchaseOrderInvoiceLabel(order: PurchaseOrder): PurchaseOrderInvoiceLabel {
  if (order?.invoice?.status === PurchaseOrderInvoiceStatus.MANUAL_ASSOCIATION) {
    return PurchaseOrderInvoiceLabel.MANUALLY_ASSOCIATED;
  } else if (order?.invoice?.status === PurchaseOrderInvoiceStatus.AUTOMATIC_ASSOCIATION) {
    return PurchaseOrderInvoiceLabel.AUTOMATICALLY_ASSOCIATED;
  } else if (order.fiscalArchivedJustification === ReasonRemoveOrder.PRIOR_TO_DEMAND) {
    return PurchaseOrderInvoiceLabel.PRIOR_TO_DEMAND;
  } else if (order.fiscalArchived) {
    return PurchaseOrderInvoiceLabel.REMOVED_FROM_FISCAL_PANEL;
  } else if (order.syncedToErp) {
    return PurchaseOrderInvoiceLabel.SENT_WITHOUT_INVOICE;
  }

  return PurchaseOrderInvoiceLabel.NOT_ASSOCIATED;
}
